import React, { Component } from "react";

import Geolocation from "react-geolocation";

export default class GeolocationComponent extends Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  onSuccess = (position) => {
    console.log("Success", position);
    var latitude = position.coords.latitude;
    var longitude = position.coords.longitude;
    this.props.onCoordinatesChanged(latitude, longitude);
  };

  render() {
    return <Geolocation onSuccess={this.onSuccess} />;
  }
}
